import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=f8644dba"
import script from "./ProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileImage.vue?vue&type=script&lang=js"
import style0 from "./ProfileImage.vue?vue&type=style&index=0&id=f8644dba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports